import * as z from "zod";

export const getOrderSourceNames = {
  name: "getOrderSourceNames" as const,
  input: z.object({}),
  output: z.array(z.string()),
};
